export const sizes = {
  navbarHeight: '3.5rem',
  sidebarWidth: '12.5rem',
  sidebarCollapse: '1.25rem',

  container: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1440px'
  },

  table: {
    '3xl': '28rem',
    '2xl': '24rem',
    xl: '18rem',
    lg: '14rem',
    md: '10rem',
    sm: '8rem',
    xs: '6rem',
    '2xs': '4rem'
  }
};
